import React, { Component } from 'react'

class Resume extends Component {
  render(){
    return(
      <div className="Resume">
        <div className="resumeSpacer">
          <h2>Spring 2026</h2>
          <p>
            <a href="https://www.dropbox.com/scl/fi/hd4w95n5jyn0wazv7a5cn/russellwells_cv_2026s.pdf?rlkey=5z3wazuki3ivxbdl5nly43i3b&dl=0">Software Engineering .pdf</a><br />
          </p>
          
          {/*<h2>Product Design & UX</h2>
          <p><a href="https://www.dropbox.com/s/lq0f5tsrdrfsn8i/rw_cv_2019s_ux.pdf?dl=1">download the .pdf</a></p>
          <h2>Hybrid Positions</h2>
          <p><a href="https://www.dropbox.com/s/z09f8mfs4rax4r2/rw_cv_2019s_hybrid.pdf?dl=1">download the .pdf</a></p>*/}
          {/*
          <h1>Experience</h1>
          <h2>Digital Hyperspace</h2> <p>2016 – Present</p>
          <p>Founder, software engineer</p>
          <p>www.sitting.io, www.sexyawakening.com</p>
          <h2>DAMN JOAN</h2> <p>Sept. – Oct. 2017 </p>
          <p>Freelance Digital Product Designer</p>
          <p>www.damnjoan.com</p>
          <h2>russdigital</h2> <p>2014 - 2015</p>
          <p>Freelance Web Designer, Developer</p>
          <p>www.battlehigh2.com, Galactic Zoo</p>
          <h2>Rootless, Inc</h2><p>2011 - 2013</p>
          <p>Founder, Front End Developer, Digital Designer</p>
          <p>www.rooless.me</p>
          <h1>Education</h1>
          <h2>University of Cincinnati</h2>
          <p>Bachelor’s of Science in Design – Digital Design</p>
          <h2>Betaspring</h2><p>Fall 2012</p>
          <p>Startup Accelerator</p>
          <h1>Skills</h1>
          <h2>Software Engineering</h2>
          <p>Javascript, react, react native, angular, node, mongodb, express</p>
          <h2>Digital Design</h2>
          <p>UX/UI, motion graphics, branding, iconography, typography, graphic design</p>
          */}
        </div>
      </div>
    );
  }
}

export default Resume



/** WEBPACK FOOTER **
 ** ./src/Resume.js
 **/